module.exports = __webpack_public_path__ + "img/guildscheduledevent2.fa4a6bfc.png";